export function push(event, competition) {
    return {
        type: 'EVENTS_PUSH_RECENT',
        event,
        competition
    };
}
